import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from './auth.service';
import { PopSettingService } from './pop-settings.service';

@Injectable({
  providedIn: 'root'
})
/// This service is called at the ngOnInit of the app.component.ts
// It is used to initalise values during the startup of the application.
// it is an alternative to APP_INITIALIZER as the app will be loaded while running
export class StartupService {
  private startupPromise?: Promise<void>;

  public constructor(
    private logger: NGXLogger,
    private popSettingService: PopSettingService,
    private authService: AuthService
  ) {}

  public async start() {
    try {
      if (!this.startupPromise) {
        this.startupPromise = this.startInternal();
      }
      return await this.startupPromise;
    } catch (error) {
      if (error.message) {
        this.logger.error(error.message);
      }

      this.logger.warn(error);
      this.startupPromise = undefined; // dont re-throw the error when retrying
      return undefined;
    }
  }

  private async startInternal() {
    await this.authService.start();

    this.authService.getAccount();

    const settings = await this.popSettingService.getSettings();
    this.logger.info(`*****pop-settings version :${settings.version}*****`);
  }
}
